<template><div><h1 id="spotlight-aufzeichnungen" tabindex="-1"><a class="header-anchor" href="#spotlight-aufzeichnungen"><span>Spotlight Aufzeichnungen</span></a></h1>
<p>Hier findest Du alle Aufzeichnung unserer <code v-pre>Spotlight</code> Webinare.</p>
<SpotlightOverview  :issues="spotlights"/></div></template>


<script setup>
import { ref } from 'vue'

const spotlights = 
[
    {
        type: 'Spotlight',
        readTime: '41 min',
        title: 'funtrade im Zusammenspiel mit vernetzten Systemen',
        tags: ['vernetzte Systeme', 'API', 'Webhooks'],
        url: '/spotlights/issues/01-system-integration.html',
        date: new Date('2026-01-30'),
        release: "10.79",
        description: '/spotlights/01-intro.md'
    }
]


</script>